import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { StorageProvider } from '../providers/storage/storage';
import { inject, Injectable } from '@angular/core';
import { LoggerWrapper } from '../providers/logger/logger-wrapper.service';
import { LoggerFactory } from '../providers/logger/logger-factory.service';
import { fromPromise } from 'rxjs/internal/observable/innerFrom';
import { IS_OFFLINE_FIRST_ENABLED } from '../utils/http-context.util';

@Injectable({ providedIn: 'root' })
export class OfflineFirstInterceptor implements HttpInterceptor {
  private storage: StorageProvider = inject(StorageProvider);
  private logger: LoggerWrapper = inject(LoggerFactory).getInstance(this);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.context.get(IS_OFFLINE_FIRST_ENABLED) === true) {
      this.logger.debug('Intercepting for Offline first');
      return fromPromise(this.getDataFromStorage(req)).pipe(
        catchError(() => {
          return next.handle(req);
        })
      );
    }
    return next.handle(req);
  }

  async getDataFromStorage(req: HttpRequest<any>): Promise<HttpEvent<any>> {
    const key = this.storage.getStorageName(req.urlWithParams);
    if (await this.storage.exist(key)) {
      this.logger.debug('Offline first for key ', key);
      return new HttpResponse<any>({
        body: await this.storage.get(key, false),
      });
    } else {
      this.logger.debug('No offline first for key ', key);
      return Promise.reject();
    }
  }
}
